mutation SyncSites($syncAllSites: Boolean) {
  syncSites(syncAllSites: $syncAllSites) {
    syncResult {
      lastSyncedAt
    }
    errors {
      message
    }
  }
}
